import { toast } from 'sonner';

const READ_ONLY_MESSAGE = "Read-only role can't make changes.";

/**
 * Defense-in-depth guard for mutation entry points.
 *
 * Usage in a hook:
 *   const canMutate = useCanMutate();
 *   const createFoo = async (input) => {
 *     if (!assertCanMutate(canMutate)) return;
 *     // ...
 *   };
 *
 * UI gating is the primary mechanism; this catches anything that slips
 * through (programmatic callers, kbd shortcuts, stale event handlers).
 */
export const assertCanMutate = (canMutate: boolean): boolean => {
  if (canMutate) return true;
  toast.error(READ_ONLY_MESSAGE);
  return false;
};
